
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hearingaidoffers",
      function () {
        return require("private-next-pages/hearingaidoffers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hearingaidoffers"])
      });
    }
  